import PropTypes from 'prop-types'
import React from 'react'

import DynamicImage from 'components/DynamicImage'
import useInViewCommon from 'hooks/useInViewCommon'

import { TextSnips, TextTest, TextWrapper, Wrapper, BoxWrapper } from './styles'

const imageSizes = {
  xs: 240,
  md: 345,
}

const WForeverBox = ({ image, text, isTextBottom, isWgs }) => {
  const [ref, inView] = useInViewCommon()

  const Box = React.useMemo(() => {
    if (!inView) {
      return null
    }

    return (
      <DynamicImage
        {...{ image, imageSizes }}
        alt="box-image"
        imageType="png"
        fitOption="contain"
      />
    )
  }, [inView, image])

  return (
    <Wrapper {...{ isTextBottom, ref }}>
      <BoxWrapper isWgs={isWgs}>{Box}</BoxWrapper>
      <TextWrapper>
        <TextTest dangerouslySetInnerHTML={{ __html: text.name }} />
        <TextSnips dangerouslySetInnerHTML={{ __html: text.snips }} />
      </TextWrapper>
    </Wrapper>
  )
}

WForeverBox.propTypes = {
  image: PropTypes.string.isRequired,
  text: PropTypes.object.isRequired,
  isWgs: PropTypes.bool,
  isTextBottom: PropTypes.bool,
}

WForeverBox.defaultProps = {
  isTextBottom: false,
}

export default WForeverBox
